import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Container = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing?.xs ?? '4px'};
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.sm ?? '8px'};
  font-size: ${(props) => props.theme.fonts?.size?.b2 ?? '14px'};
`;

export const Spinner = styled.span`
  width: 14px;
  height: 14px;
  border: 2px solid var(--color-neutral-200, rgba(0, 0, 0, 0.1));
  border-top-color: var(--color-primary, #2563eb);
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  flex-shrink: 0;
`;

export const CheckIcon = styled.span`
  color: var(--color-success, #22c55e);
  font-size: 14px;
  flex-shrink: 0;
`;

export const FailIcon = styled.span`
  color: var(--color-error, #ef4444);
  font-size: 14px;
  flex-shrink: 0;
`;

export const Name = styled.span`
  color: ${(props) => props.theme.colors?.body ?? 'inherit'};
`;

export const Duration = styled.span`
  color: var(--color-body-muted, #666);
  font-size: 12px;
  margin-left: auto;
`;
